import { render, staticRenderFns } from "./Expectation.vue?vue&type=template&id=ff55ffd4&scoped=true"
import script from "./Expectation.vue?vue&type=script&lang=js"
export * from "./Expectation.vue?vue&type=script&lang=js"
import style0 from "./Expectation.vue?vue&type=style&index=0&id=ff55ffd4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff55ffd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff55ffd4')) {
      api.createRecord('ff55ffd4', component.options)
    } else {
      api.reload('ff55ffd4', component.options)
    }
    module.hot.accept("./Expectation.vue?vue&type=template&id=ff55ffd4&scoped=true", function () {
      api.rerender('ff55ffd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/rubricSetting/Add/components/Expectation.vue"
export default component.exports